import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import styles from '../styles';
import { appNames, reportingStandards } from '../../constants';
import { HeaderOTCQX } from '../headers';
import { Footer } from '../components';
import Cover from '../pages/Cover';
import CompanyInfo from '../pages/CompanyInfo';
import ReportingStandards from '../pages/ReportingStandards';
import AdditionalServices from '../pages/AdditionalServices';
import EligibilityStandards from '../pages/EligibilityStandards';
import Officers from '../pages/Officers';
import Directors from '../pages/Directors';
import ControlPersonIndividual from '../pages/ControlPersonIndividual';
import ControlPersonCorpEntity from '../pages/ControlPersonCorpEntity';
import SPTransferAgent from '../pages/SPTransferAgent';
import SPAuditor from '../pages/SPAuditor';
import SPSecCounsel from '../pages/SPSecCounsel';
import SPInvestorRelationsServices from '../pages/SPInvestorRelationsServices';
import SPInvestmentBank from '../pages/SPInvestmentBank';
import SecurityDetails from '../pages/SecurityDetails';
import SecurityOwnership from '../pages/SecurityOwnership';
import LegalDisciplinaryHistory from '../pages/LegalDisciplinaryHistory';
import PrimaryContacts from '../pages/PrimaryContacts';
import AuthorizedUsers from '../pages/AuthorizedUsers';
import BillingContacts from '../pages/BillingContacts';
import BackgroundCheck from '../pages/BackgroundCheck';
import SuppDocsRequired from '../pages/SuppDocsRequired';
import SuppDocsAdditional from '../pages/SuppDocsAdditional';
import PaymentDetails from '../pages/PaymentDetails';

const OTCQX_INTL = appNames.OTCQX_INTL;

const TemplateOTCQXIntl = ({ application, documents, owners, docTypes, appStates }) => {
  const status = application && application.status;
  const appStateObj = appStates && appStates.find(state => state.stateId === status);
  const statusDesc = appStateObj && appStateObj.description || application.status;
  const symbol = application && application.primarySymbol;
  const companyName = application && application.companyInfo && application.companyInfo.name;
  const isIntlReportStnd = application && application.reportingStandard === reportingStandards.INTERNATIONAL;
  const draftMgCertRequired = !isIntlReportStnd;

  return (
    <Document style={styles.document} >
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <Cover type={OTCQX_INTL} status={statusDesc} symbol={symbol} symbolType={'OTCQX'} companyName={companyName} owners={owners} people={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <CompanyInfo data={application.companyInfo} type={OTCQX_INTL} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <EligibilityStandards data={application.eligibilityStandards} type={OTCQX_INTL} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <ReportingStandards data={application.reportingStandard} cik={application.cikNumber} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <Officers data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <Directors data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <ControlPersonIndividual data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <ControlPersonCorpEntity entities={application.corporateEntityList} people={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SecurityDetails data={application.securityDetails} type={OTCQX_INTL} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SecurityOwnership people={application.peopleList} entities={application.corporateEntityList} securities={application.securityDetails && application.securityDetails.securityList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <LegalDisciplinaryHistory data={application.legalHistory} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <PrimaryContacts data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <AuthorizedUsers data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <BillingContacts data={application.peopleList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <BackgroundCheck type={OTCQX_INTL} people={application.peopleList} entities={application.corporateEntityList} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SPTransferAgent data={application.transferAgents} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SPAuditor data={application.auditors} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SPSecCounsel data={application.securitiesCounsels} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SPInvestorRelationsServices data={application.investorRelations} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SPInvestmentBank data={application.investmentBanks} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SuppDocsRequired docs={documents} docTypes={docTypes} shareHoldRequired auditAnnualReportRequired logoRequired draftMgCertRequired={draftMgCertRequired} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <SuppDocsAdditional docs={documents} docTypes={docTypes} shareHoldRequired auditAnnualReportRequired logoRequired draftMgCertRequired={draftMgCertRequired} />
        <Footer companyName={companyName} />
      </Page>
      <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <AdditionalServices data={application.additionalServices} hasVIC />
        <Footer companyName={companyName} />
      </Page>
      {application.payment && <Page style={styles.page} size='A4'>
        <HeaderOTCQX type={OTCQX_INTL} />
        <PaymentDetails data={application.payment} submitDate={application.submitDate} />
        <Footer companyName={companyName} />
      </Page>}
    </Document>
  );
};

export default TemplateOTCQXIntl;
